import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import axios from "../axios-orders";
import { queryKeys } from "./queryKeys";
import { NotificationsPaginatedResponse } from "../types";

const getUserNotifications = async (page = 0) => {
  const { data } = await axios.get(`/notifications/${page}`);
  return data;
};

export const useNotifications = (page = 0) =>
  useQuery<NotificationsPaginatedResponse>({
    queryKey: [queryKeys.NOTIFICATIONS, page],
    queryFn: () => getUserNotifications(page),
  });

const getUnreadNotifications = async () => {
  const { data } = await axios.get("/notifications/unread/count");
  return data;
};

export const useUnreadNotifications = () =>
  useQuery({
    queryKey: [queryKeys.UNREAD_NOTIFICATIONS],
    queryFn: getUnreadNotifications,
  });

const markNotificationAsRead = async (notificationId: string) => {
  const { data } = await axios.put(`/notifications/${notificationId}/read`);
  return data;
};

export const useMarkNotificationAsRead = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: markNotificationAsRead,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [queryKeys.NOTIFICATIONS] });
      queryClient.invalidateQueries({
        queryKey: [queryKeys.UNREAD_NOTIFICATIONS],
      });
    },
  });
};

const markAllNotificationsAsRead = async () => {
  const { data } = await axios.put("/notifications/read-all");
  return data;
};

export const useMarkAllNotificationsAsRead = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: markAllNotificationsAsRead,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [queryKeys.NOTIFICATIONS] });
      queryClient.invalidateQueries({
        queryKey: [queryKeys.UNREAD_NOTIFICATIONS],
      });
    },
  });
};
